import Button from '@components/V4/Button';
import Input from '@components/V4/Inputs/Input';
import Modal from '@components/V4/Modal/Modal';
import { Flag } from '@shared/common';
import { memo, useState, useEffect } from 'react';

type Props = {
  isOpen: boolean;
  flag: Flag | null;
  saving: boolean;
  onClose: () => void;
  onSave: (comment: string) => void;
};

const AddCommentModal = memo(({ isOpen, flag, saving, onClose, onSave }: Props) => {
  const [comment, setComment] = useState('');
  useEffect(() => {
    if (isOpen) setComment('');
  }, [isOpen, flag?._id]);

  return (
    <Modal key={flag?._id} isOpen={isOpen} onClose={onClose} size="small">
      <Modal.Header className="relative font-raleway text-xl font-bold text-center mb-6">
        <h3>Add Comment for</h3>
        <i className="block mt-1 text-base font-normal">{flag?.description}</i>
      </Modal.Header>
      <Modal.Body>
        <Input
          id="comment"
          name="comment"
          type="text"
          label="Add Comment"
          rows={10}
          value={comment}
          onChange={(v: any) => setComment(typeof v === 'string' ? v : v?.target?.value ?? '')}
        />
        <div className="flex justify-end gap-4 mt-6">
          <Button variant="secondary" onClick={onClose} buttonText="Cancel" disabled={saving} />
          <Button
            variant="primary"
            onClick={() => onSave(comment.trim())}
            buttonText={saving ? 'Saving…' : 'Save'}
            disabled={saving || !comment.trim()}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
});

export default AddCommentModal;
